import React from "react";

export const ORG_TYPES = { clinique: "Clinique", hopital: "Hôpital", centre_imagerie: "Centre d'imagerie", cabinet_dentaire: "Cabinet dentaire", centre_medical: "Centre médical", autre: "Autre" };
export const SECTEURS = { prive: "Privé", public: "Public", parapublic: "Parapublic" };
export const ROLE_LABEL = { admin_cep: "Admin CEP", expert_cep: "Expert CEP", client_admin: "Client Admin", client_user: "Client Utilisateur" };
export const USER_STATUT = {
  invitation_en_attente: { label: "Invitation en attente", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  actif: { label: "Actif", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  suspendu: { label: "Suspendu", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
};

export const ROLES = { ADMIN: "admin_cep", EXPERT: "expert_cep", CLIENT_ADMIN: "client_admin", CLIENT_USER: "client_user" };
export const isCep = (r) => r === ROLES.ADMIN || r === ROLES.EXPERT;
export const isClientRole = (r) => r === ROLES.CLIENT_ADMIN || r === ROLES.CLIENT_USER;
export const isAdminCep = (r) => r === ROLES.ADMIN;
export const canManageBusiness = (r) => isCep(r) || r === ROLES.CLIENT_ADMIN;

export const STATUT_ORG = { actif: { label: "Actif", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" }, inactif: { label: "Inactif", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" } };

export const EQUIP_TYPE = { radiographie: "Radiographie", scanner: "Scanner", mammographie: "Mammographie", panoramique_dentaire: "Panoramique dentaire", retroalveolaire: "Rétroalvéolaire", cbct: "CBCT", arceau_mobile: "Arceau mobile", interventionnel: "Interventionnel", autre: "Autre" };
export const LOCAL_TYPE = { salle_radio: "Salle de radiographie", salle_scanner: "Salle de scanner", salle_mammo: "Salle de mammographie", cabinet_dentaire: "Cabinet dentaire", salle_interventionnelle: "Salle interventionnelle", local_technique: "Local technique", autre: "Autre" };

export const AUTOR_STATUT = {
  a_verifier: { label: "À vérifier", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  valide: { label: "Autorisation valide", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  renouvellement_a_preparer: { label: "Renouvellement à préparer", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  dossier_en_cours: { label: "Dossier en cours", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  expiree: { label: "Expirée / non conforme", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
};

export const PRIORITE = {
  critique: { label: "Critique", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  haute: { label: "Haute", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  moyenne: { label: "Moyenne", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  faible: { label: "Faible", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
};

export const NC_STATUT = {
  ouverte: { label: "Ouverte", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  en_cours: { label: "En cours", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  en_attente_preuve: { label: "En attente de preuve", cls: "bg-purple-500/15 text-purple-300 border-purple-500/30" },
  a_verifier: { label: "À vérifier", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  cloturee: { label: "Clôturée", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
};

export const ACTION_STATUT = {
  a_faire: { label: "À faire", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  en_cours: { label: "En cours", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  en_attente: { label: "En attente", cls: "bg-purple-500/15 text-purple-300 border-purple-500/30" },
  realisee: { label: "Réalisée", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  verifiee: { label: "Vérifiée", cls: "bg-emerald-600/20 text-emerald-300 border-emerald-600/40" },
  annulee: { label: "Annulée", cls: "bg-slate-600/20 text-slate-400 border-slate-600/40" },
};

export const CHECKUP_STATUT = {
  planifie: { label: "Planifié", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  en_cours: { label: "En cours", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  realise: { label: "Réalisé", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  cloture: { label: "Clôturé", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
};

export const REPONSE = {
  conforme: { label: "Conforme", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  non_conforme: { label: "Non conforme", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  partiellement_conforme: { label: "Partiellement conforme", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  non_applicable: { label: "Non applicable", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  a_verifier: { label: "À vérifier", cls: "bg-slate-700/40 text-slate-400 border-slate-600/30" },
};

export const DEMANDE_STATUT = {
  nouvelle: { label: "Nouvelle", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  contactee: { label: "Contactée", cls: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  devis_a_preparer: { label: "Devis à préparer", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  devis_envoye: { label: "Devis envoyé", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  acceptee: { label: "Acceptée", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  realisee: { label: "Réalisée", cls: "bg-emerald-600/20 text-emerald-300 border-emerald-600/40" },
  annulee: { label: "Annulée", cls: "bg-slate-600/20 text-slate-400 border-slate-600/40" },
};

export const DOC_TYPE = { autorisation: "Autorisation ARSN", rapport: "Rapport", preuve: "Preuve", procedure: "Procédure", certificat: "Certificat", autre: "Autre" };
export const NIVEAU = { critique: "Critique", haute: "Haute", moyenne: "Moyenne", faible: "Faible" };

export const SCORE_DISCLAIMER = "Indicateur interne CEP de pilotage de la conformité. Il ne constitue ni une certification ni une autorisation ARSN.";

export const ARSN_PIECE_STATUT = {
  manquant: { label: "Manquant", cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" },
  fourni: { label: "Fourni", cls: "bg-blue-500/15 text-blue-400 border-blue-500/30" },
  a_verifier: { label: "À vérifier", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  valide: { label: "Validé", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
  a_corriger: { label: "À corriger", cls: "bg-orange-500/15 text-orange-400 border-orange-500/30" },
  expire: { label: "Expiré", cls: "bg-red-500/15 text-red-400 border-red-500/30" },
  expiration_proche: { label: "Expire bientôt", cls: "bg-yellow-500/15 text-yellow-400 border-yellow-500/30" },
};
export const ARSN_ACTIVITE = { radiologie_diagnostique: "Radiologie diagnostique", radiologie_interventionnelle: "Radiologie interventionnelle", cabinet_dentaire: "Cabinet dentaire" };
export const ARSN_DEMANDE = { nouvelle: "Nouvelle demande", renouvellement: "Renouvellement" };

export function ScoreDisclaimer({ className = "" }) {
  return (
    <p data-testid="score-disclaimer" className={`rounded-lg border border-amber-500/25 bg-amber-500/5 px-3 py-2 text-xs italic leading-snug text-amber-300/90 ${className}`}>
      {SCORE_DISCLAIMER}
    </p>
  );
}

export function Badge({ map, value, "data-testid": tid }) {
  const item = (map && map[value]) || { label: value, cls: "bg-slate-500/15 text-slate-300 border-slate-500/30" };
  return <span data-testid={tid} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${item.cls}`}>{item.label}</span>;
}

export function PageHeader({ title, subtitle, icon: Icon, children }) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        {Icon && <div className="mt-1 flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary ring-1 ring-primary/20"><Icon className="h-5 w-5" /></div>}
        <div>
          <h1 className="font-display text-2xl font-extrabold tracking-tight text-slate-50 sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
        </div>
      </div>
      {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card/40 py-16 text-center">
      {Icon && <Icon className="mb-3 h-10 w-10 text-slate-600" />}
      <p className="font-display text-lg font-semibold text-slate-300">{title}</p>
      {subtitle && <p className="mt-1 max-w-sm text-sm text-slate-500">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <label className="text-xs font-semibold uppercase tracking-wide text-slate-400">{label}</label>
      {children}
    </div>
  );
}
